export default {
  name: 'link',
  type: 'layout',
  active: false,
  data: {
    type: 'page',
    url: {},
    pageId: '',
    target: false
  }
}
